import React from 'react';
import styles from './DirectorInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import PhoneInput from '../../../../components/PhoneInput';

const ContactInformations = ({ company, onCompanyChange }) => {
    return (
        <Card className={styles.card} title="Coordonnées" classTitle="title-green">
            <div className={styles.group}>
                <PhoneInput
                    className={styles.field}
                    label="Téléphone"
                    name="phone"
                    id="director_phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={company?.phone || ''}
                    onChange={onCompanyChange}
                    autoComplete="tel"
                />
                <TextInput
                    className={styles.field}
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="email@example.com"
                    value={company?.email || ''}
                    onChange={onCompanyChange}
                    required
                />
            </div>
        </Card>
    );
};

export default ContactInformations;